// extracted by mini-css-extract-plugin
export default {"container":"ErrorComponent_container__JfSP1"};